import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { SupervisionError, Site, Panel } from 'solar-bo';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SolarBaseComponent } from '@solar/solar/solar-base/solar-base.component'
import { TimePerf } from 'shtools';


@Component({
  selector: 'app-panellocator',
  templateUrl: './panellocator.component.html',
  styleUrls: ['./panellocator.component.scss']
})
export class PanelLocatorComponent extends SolarBaseComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() panel: any;
  @Input() issue: SupervisionError;
  locatorAsString: string;
  locatorEdit: any;
  panelFound: Panel;

  @Output() panelChangeEvent: EventEmitter<Panel> = new EventEmitter();

  constructor() {
    super();

  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    let typeChange = changes['issue'];
    if (typeChange) {
      this.configLocator();
    }
  }

  ngAfterViewInit() {

  }

  public static openModal(dialog: MatDialog, panel: any, title?: string, titlesub?: string): MatDialogRef<PanelLocatorComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "500px";
    //dialogConfig.height = "400px";
    //dialogConfig.data = {entity2edit: entity2edit };

    let dialogRef: MatDialogRef<PanelLocatorComponent>;
    dialogRef = dialog.open(PanelLocatorComponent, dialogConfig);
    //dialogRef.componentInstance.configureHeaders(title,titlesub);
    dialogRef.componentInstance.panel = panel;

    return dialogRef;
  }

  form = new FormGroup({});
  configLocator() {
    if (this.issue == null) {
      this.locatorAsString = "";
      this.panelFound = null;
      return;
    }
    this.panelFound = this.issue.info.panel;
    this.locatorAsString = this.uiLocator(this.issue);
    //console.log(this.issue);
    console.log(this.issue.info.panel);

    let _locator = this.issue.info.panel.locator;
    let keys = Object.keys(_locator);

    let siteLocator = this.issue.supervision.site.info.locator;//info with description about locator
    let loc: any[] = [];
    for (let k of keys) {
      let tooltip: string = "No locator description found. Please contact your adminstrator.";
      try {
        if (siteLocator) {
          tooltip = siteLocator[k];
        }
      }
      catch (err) {
        //
      }
      let item = { key: k, value: _locator[k], tooltip: tooltip };
      loc.push(item);
    }
    this.locatorEdit = loc;

    this.form = new FormGroup({});
    this.locatorEdit.forEach(x => {
      //this.form.addControl(x.key, new FormControl(x.value, Validators.required));
      this.form.addControl(x.key, new FormControl(x.value));
    });
  }

  getTooltipFor(key) {
    try {
      let tt = this.locatorEdit.find(item => item.key === key).tooltip;
      return tt;
    }
    catch (err) {
      return "No locator description found. Please contact your adminstrator.";
    }
  }

  async findpanel_click() {  
    await this.findpanel();
    this.panelChangeEvent.next(this.panelFound);
  }

  private async findpanel() {
    let form_locator: any = this.form.value;

    this.panelFound = null;

    let keys = Object.keys(form_locator);
    //check if all keys have value
    let queryStringLocator="";
    let querySep="";
    for (let k of keys) {
      let value = form_locator[k];
/*       if (value==null || value) {
        console.log("findpanel some key is empty", keys);
        return;
      } */
      queryStringLocator+=querySep + k+"="+encodeURIComponent(""+value);
      querySep="&"
    }

    let panel:Panel=await this.solarService.siteGetPanelByLocator(this.issue.supervision.site.id,queryStringLocator);

    //todo: cuando se produce un error devuelve la promesa en lugar de generar error. No es asi como deberia funcionar
    //, comprobar en la documentacion de angular con observables que es donde debe estar el error, ya que 
    // https://javascript.info/async-await#:~:text=The%20await%20keyword%20before%20a,Otherwise%2C%20it%20returns%20the%20result.
    //mientras comprobamos si tiene alguna propiedad del objeto panel para salir del paso
    if (panel &&  panel.hasOwnProperty('id_panel_type')){
      this.panelFound=panel;
    }
    //this.findPanelFromList(keys);

  }

  private findPanelFromList(keys) {
    let form_locator: any = this.form.value;
    let panels: Panel[] = this.solarService.solarCacheSvc.sitePanelsById(this.issue.supervision.site.id);
    //a lo bruto es lo mas rapido
    if (keys.length == 3) {
      this.panelFound = panels.find(panel => panel.locator.L1 == form_locator.L1
        && panel.locator.L2 == form_locator.L2
        && panel.locator.L3 == form_locator.L3
      );
    } else if (keys.length == 4) {
      this.panelFound = panels.find(panel => panel.locator.L1 == form_locator.L1
        && panel.locator.L2 == form_locator.L2
        && panel.locator.L3 == form_locator.L3
        && panel.locator.L4 == form_locator.L4
      );
    } else if (keys.length == 5) {
      this.panelFound = panels.find(panel => panel.locator.L1 == form_locator.L1
        && panel.locator.L2 == form_locator.L2
        && panel.locator.L3 == form_locator.L3
        && panel.locator.L4 == form_locator.L4
        && panel.locator.L5 == form_locator.L5
      );
    } else if (keys.length == 6) {
      this.panelFound = panels.find(panel => panel.locator.L1 == form_locator.L1
        && panel.locator.L2 == form_locator.L2
        && panel.locator.L3 == form_locator.L3
        && panel.locator.L4 == form_locator.L4
        && panel.locator.L5 == form_locator.L5
        && panel.locator.L6 == form_locator.L6
      );
    } else if (keys.length == 7) {
      this.panelFound = panels.find(panel => panel.locator.L1 == form_locator.L1
        && panel.locator.L2 == form_locator.L2
        && panel.locator.L3 == form_locator.L3
        && panel.locator.L4 == form_locator.L4
        && panel.locator.L5 == form_locator.L5
        && panel.locator.L6 == form_locator.L6
        && panel.locator.L7 == form_locator.L7
      );
    }
  }

  async getSelectedPanel() {
    if (this.panelFound == null) {
      await this.findpanel();
    }
    else {
      //check if 
      /* let form_locator: any = this.form.value;
    let keys = Object.keys(form_locator); */
    }


    return this.panelFound;
  }

  /**
   * to show the locator in lists
   * @param issue 
   */
  uiLocator(issue: SupervisionError) {
    let panelPatternList = Site.getPanelPattern(issue.supervision.site, "list");
    
    return SupervisionError.uiLocator(issue, panelPatternList);
  }

  input_onchange(event: KeyboardEvent) {
    //console.log(event);
  }

  async input_keyPress(event: KeyboardEvent) {
    //console.log(event);
    try {
      if (event.key === "Enter" && event.ctrlKey == false) {
        await this.findpanel();
        this.panelChangeEvent.next(this.panelFound);
      }
    }
    catch (err) {
      this.notifyerror(err, "Some error ocurred with your input. Please verify the data entered");
    }

  }


  async input_onblur($event) {
    try {

      //console.log($event);
      let form_locator: any = this.form.value;
      let keys = Object.keys(form_locator);

      if (this.panelFound) {
        for (let k of keys) {
          let value = form_locator[k];
          if (value != this.panelFound.locator[k]) {
            await this.findpanel();
            this.panelChangeEvent.next(this.panelFound);
            return;
          }
        }
      } else {
        await this.findpanel();
        this.panelChangeEvent.next(this.panelFound);
      }

    }
    catch (err) {
      this.notifyerror(err, "Some error ocurred with your input. Please verify the data entered");
    }


  }


}
